export enum Regions {
  Moscow = 1,
  Spb = 2,
  MoscowArea = 4593,
  SpbArea = 4588,
}
